import React, { useState } from "react";
import Slider from "react-slick";
import Logo1 from '../../assets/images/logo1.png'
import Logo2 from '../../assets/images/logo2.png'
import Logo3 from '../../assets/images/logo3.png'
import Logo4 from '../../assets/images/logo4.png'
import Logo5 from '../../assets/images/logo5.png'
import Logo6 from '../../assets/images/logo6.png'


function Banner() {
    const settings = {
        dots: false,
        infinite: true,
        // autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 0,
        centerMode: false,

        responsive: [
            {
                breakpoint: 1350,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            }

        ]
    };
    return (
        <section className="logo-slider main-padding section-margin">
            <div className="container-fluid p-0">
                <Slider className="logo-list" {...settings}>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo1} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo2} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo3} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo4} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo5} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo6} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <a href="#">
                                <img src={Logo1} alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>

                </Slider>
            </div>
        </section>
    )
}
export default Banner;